import ClassNames from 'classnames'
import React from 'react'
import {
  ContainerBase
} from './../../base'
import { ContainerWrapper } from './styled'

export class Container extends React.PureComponent {
  render() {
    const {
      children,
      className,
      ui
    } = this.props

    // props for css classes
    const classes = ClassNames(
      className,
    )

    return (
      <React.Fragment>
        {(() => {
          switch (ui) {
            case 'fullViewBgImageCover':
              return (
                <ContainerWrapper
                  {...this.props}
                  className={classes}
                  calcMinHeight='100dvh'
                  bgSize='cover'
                  bgRepeat='no-repeat'
                  bgPosition='center'
                >
                  {children}
                </ContainerWrapper>
              )
            case 'fullView':
              return (
                <ContainerWrapper
                  {...this.props}
                  className={classes}
                  height='100'
                  heightUnit='vh'
                >
                  {children}
                </ContainerWrapper>
              )
            case 'fullViewCenter':
              return (
                <ContainerWrapper
                  {...this.props}
                  className={classes}
                  calcMinHeight='100dvh'
                  justify='center'
                  align='center'
                >
                  {children}
                </ContainerWrapper>
              )
            case 'standAlone':
              return (
                <ContainerWrapper
                  {...this.props}
                  className={ClassNames(
                    className,
                    'is-standalone',
                  )}
                >
                  {children}
                </ContainerWrapper>
              )
            default:
              return (
                <ContainerWrapper
                  {...this.props}
                  className={classes}
                >
                  {children}
                </ContainerWrapper>
              )
          }
        })()}
      </React.Fragment>
    )
  }

  static defaultProps = {
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
